import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-39",
  "use": "icon-button_icon-39-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-39\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M8.539 6H21a1 1 0 011 1v10a1 1 0 01-1 1H8.535a1 1 0 01-.695-.281l-5.106-4.94a1 1 0 01-.008-1.429l5.109-5.06A1 1 0 018.539 6z\" /><path stroke-linecap=\"round\" d=\"M11.537 14.475l4.949-4.95M11.537 9.525l4.949 4.95\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol